export function msToHoursBalance(duration: number): string {
  const seconds = Math.floor((duration / 1000) % 60);
  const minutes = Math.floor((duration / (1000 * 60)) % 60);
  const hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  const hoursStr = hours < 10 ? "0" + hours : hours.toString();
  const minutesStr = minutes < 10 ? "0" + minutes : minutes.toString();
  const secondsStr = seconds < 10 ? "0" + seconds : seconds.toString();

  return `${hoursStr}:${minutesStr}:${secondsStr}`;
}

export function convertMsToHourMinSec(ms: number): string {
  const hours = Math.floor(ms / 3600000); // 1 hour = 3600000 ms
  const minutes = Math.floor((ms % 3600000) / 60000); // 1 minute = 60000 ms
  const seconds = Math.floor(((ms % 360000) % 60000) / 1000); // 1 second = 1000 ms

  // Ensure double digits for minutes and seconds
  const formattedMinutes = minutes.toString().padStart(2, "0");
  const formattedSeconds = seconds.toString().padStart(2, "0");

  // show only hours if it is more than 0
  if (hours > 0) {
    return `${hours}:${formattedMinutes}:${formattedSeconds}`;
  }

  return `${formattedMinutes}:${formattedSeconds}`;
}
